import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const saveUserToFirestore = async (user, role = 'student') => {
  if (!db) {
    return;
  }

  const userRef = doc(db, 'users', user.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) {
    try {
      await setDoc(userRef, {
        uid: user.uid,
        email: user.email,
        role: role,
        createdAt: new Date().toISOString(),
      });
    } catch (error) {
      throw error;
    }
  } else {
    // If user exists, make sure we at least save their email in case it was missing
    try {
      await setDoc(userRef, { email: user.email }, { merge: true });
    } catch (error) {
      console.error("Failed to update user email:", error);
    }
  }
};
